import formValidation from '../../../../../../mixins/validable';
import { getBiztNameById, MINDEN_BIZTOSITO } from '../../../../../../modules/Biztosito';

export default {

    mixins: [formValidation],
    data() {
        return {
            visible: true,
            propName: '',
        };
    },
    props: {
        biztositoid: {
            type: Number,
            required: true,
            validator: (v) => MINDEN_BIZTOSITO.includes(v),
        },
        titleExtra: {
            type: String,
            required: true,
        },
    },
    mounted() {
        // this.visible = this.getFieldCount() > 0
        this.propName = getBiztNameById(this.biztositoid);
        if (this.$store.getters.tarifaData[this.propName] == null) {
            this.$store.commit('setProp', {
                path: `tarifaData.${this.propName}`,
                value: {},
            });
        }
    },
    methods: {
        getFieldCount() {
            return this.$refs['ajanlat-adatok'].$el.length;
        },

        validate() {
            return this.validateForms(['ajanlat-adatok']);
        },
    },

    computed: {
        kedvezmenyek() {
            return this.$store.getters.kedvezmenyekbiztosito[this.biztositoid];
        },
        egyuttkotve() {
            return this.$store.getters.azonosKockkezd
                && (
                    this.$store.getters.egyuttkotottBiztosito === this.biztositoid
                    || (
                        this.$store.selected?.kgfb != null
                        && this.$store.selected?.casco != null
                        && this.$store.selected.kgfb === this.$store.selected.casco
                    )
                );
        },
    },
};
